import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { noop } from '../../utils';
export var defaultAudioContext = {
  duration: 0,
  togglePlay: function () {
    var _togglePlay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function togglePlay() {
      return _togglePlay.apply(this, arguments);
    }

    return togglePlay;
  }(),
  play: function () {
    var _play = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function play() {
      return _play.apply(this, arguments);
    }

    return play;
  }(),
  pause: noop,
  isPlaying: false,
  seek: noop,
  fastForward: noop,
  rewind: noop,
  speed: 1.0,
  setSpeed: noop,
  error: null
};